import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { MapHelperService } from '@app/core/services/map-helper.service';
import { BakelorMap, BakelorMapService } from 'bakelor-map';
import { debounceTime, Subject } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { v4 as uuidv4 } from 'uuid';
declare let L: any;

@Component({
    selector: 'app-map-item',
    templateUrl: './map-item.component.html',
    styleUrls: ['./map-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MapItemComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  public containerId: string = uuidv4();

  @Input()
  height: number = 200;

  _target: number[] = [0, 0];
  @Input()
  public set target(value: number[]) {
    let changed = false;
   
    if (this._target[0] !== value[0] || this._target[1] !== value[1]) { changed = true; }

    this._target = value;

    if (changed) { this.settingsDebouncer.next(); }
  }

  public get target(): number[] {
    return this._target;
  }

  _zoom: number = 5;
  @Input()
  public set zoom(value: number) {

    let changed = false;
    if (this._zoom !== value) { changed = true; }

    this._zoom = value;

    if (changed) { this.settingsDebouncer.next(); }


  }
  public get zoom(): number {
    return this._zoom;
  }

  baseTile = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png',
    {
      detectRetina: true,
      maxNativeZoom: 25,
      maxZoom: 25,
      updateWhenIdle: true,
      keepBuffer: 10,
      updateInterval: 300,
      updateWhenZooming: true,
      pane: 'tilePane',
      crossOrigin: true
    });

  layers = {
    tiles: [this.baseTile]
  };

  @Input()
  targetUrl: string;

  _geojsonItems: string[] = [];

  @Input()
  public set geoJsonItems(value: string[]) {
    this._geojsonItems = value;
    this.settingsDebouncer.next();
  }

  public get geoJsonItems(): string[] {
    return this._geojsonItems;
  }

  showTargetLink: boolean = false;

  _tempLayers: any[] = [];

  settingsDebouncer: Subject<void> = new Subject<void>();

  _mapReady = false;
  canRenderMap = false;

  private connectionObserver?: MutationObserver;

  constructor(private mapService: BakelorMapService,
    public mapHelperService: MapHelperService,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly changeDetectorRef: ChangeDetectorRef) {

    this.target = [0, 0];
    this.settingsDebouncer
       .pipe(debounceTime(500))
      .subscribe(value => this.settingsChanged());
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.renderMapWhenConnected();
  }

  ngOnDestroy(): void {
    this.connectionObserver?.disconnect();
  }

  onMapReady($event: BakelorMap): void {
    this.mapService.map.nativeInstance.createPane('geoJsonPane').style.zIndex = 1000;
    this.mapService.map.nativeInstance.createPane('geoJsonLabelPane').style.zIndex = 1001;
    this.mapService.map.nativeInstance.whenReady(() => {
      setTimeout(() => {
        this.mapService.map.nativeInstance.invalidateSize(true);
        this._mapReady = true;
      }, 500);

    });
  }

  settingsChanged(): void {

    if (!this._mapReady) { return; }

    this.renderGeoJson(this.geoJsonItems);

    //check if target is valid
    


    if (Number.isNaN(this.target[0]) || Number.isNaN(this.target[1])) {
      return;
    }

    if (this.target[0] == undefined || this.target[1] == undefined) {
      return;
    }

    const coord = new L.LatLng(this.target[0], this.target[1]);

    this.mapService.map?.nativeInstance.flyTo(coord, this.zoom, {
      animate: true,
      easeLinearity: 0.25,
      noMoveStart: false,
      duration: 1.2,
      fadeAnimation: true,
      zoomAnimation: true
    });

  }


  renderGeoJson(items: string[]): void {

    this._tempLayers.forEach((layer) => {
      this.mapHelperService.removeMapLabels(layer);
      this.mapHelperService.removeGeoJSONFeatures(this.mapService.map.nativeInstance, layer);
    });

    items.forEach((item) => {

      if (!item) { return; }
      const geoJSON = JSON.parse(item);

      const layer = this.mapHelperService.generateLayerFromGeoJSON(this.mapService.map, geoJSON,
        { pane: 'geoJsonPane', labelPane: 'geoJsonLabelPane', minZoom: this.zoom });

      this.mapService.map.addLayer(layer);

      this._tempLayers.push(layer);


      // calculate layer center
      // const bounds = layer.getBounds();
      // const center = bounds.getCenter();
      // this.target = [parseFloat(center.lat), parseFloat(center.lng)];

    });

  }

  private renderMapWhenConnected(): void {
    if (this.canRenderMap) {
      return;
    }

    if (this.elementRef.nativeElement.isConnected) {
      this.connectionObserver?.disconnect();
      this.connectionObserver = undefined;
      this.canRenderMap = true;
      this.changeDetectorRef.detectChanges();
      return;
    }

    if (!this.connectionObserver) {
      this.connectionObserver = new MutationObserver(() => this.renderMapWhenConnected());
      this.connectionObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

}
